module.exports = __webpack_public_path__ + "static/media/4 Logo.fundo.transparente.bd27c11a.png";